import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class RokoviTrajanjaService {
  constructor(private _http: HttpClient) {}

  dohvatiSkladista_Pekar_i_Tomo(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_skladista_pekar_i_tomo', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http.post(AppConfig.ipAddress + 'artiklPopis', a)
      .pipe(map((res: any) => res));
  }

  lotbrojeviPopisRokoviTrajanja(a: any) {
    return this._http.post(AppConfig.ipAddress + 'lotbrojeviPopisRokoviTrajanja', a)
      .pipe(map((res: any) => res));
  }
}